import LbTableColumn from '../table/src/table-column';

/* istanbul ignore next */
LbTableColumn.install = function(Vue) {
  Vue.component(LbTableColumn.name, LbTableColumn);
};

export default LbTableColumn;
